import axios from 'axios';
import history from "./history";
import { apiUrl } from "./constants";

class Request {
    // Initialize axios
    init = (timeOut) => {
        return axios.create({
            baseURL: apiUrl(),
            timeout: timeOut ? timeOut : 15000
        });
    };

    initXML = () => {
        return axios.create({
            timeout: 15000,
            headers: {
            "Content-Type": "application/xml; charset=utf-8"
            }
        });
    }

    // axios get method definition
    get = (cls, endpoint, payload, handler = false) => {
        let self = this;
        let instance = this.init();
        instance.defaults.responseType = "json";
        let callback = handler;
        let params = '';
        if (payload) params = '?payload=' + JSON.stringify(payload);
        return instance
            .get(endpoint + params)
            .then(response => {
                return response.data ? response.data : [];
            })
            .catch(error => {
                return self.handleError(error);
            })
            .then(response => {
                if (callback) callback(response);
                return response;
            });
    };

    // axios get XML Feed definition
    getXML = (cls, endpoint) => {
        let self = this;
        let instance = this.initXML();
        let xmlToJsonData;
        var parseString = require('xml2js').parseString;
        return instance
        .get(endpoint, {responseType: 'text'})
        .then(response => {
            var xml = response && response.data;
            parseString(xml, function (err, result) {
            xmlToJsonData = result;
            });
            if (!xml) throw new Error("No response data");
            return xmlToJsonData ? xmlToJsonData : [];
        })
        .catch(error => {
            return self.handleError(error);
        })
    };

    handleError = error => {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            let msg = "";
            if (error.response.data.message) {
            msg = error.response.data.message;
            } else {
            msg = error.message
            }
            // Handle 400 errors
            if (error.response.status === 400) {
                return {
                    status: "error",
                    message: msg ? msg : "Bad Request error"
                };
            };
            // Handle 500 errors
            if (error.response.status === 500) {
                return {
                    status: "error",
                    message: msg ? msg : "Server error"
                };
            };
            // Handle 401 errors
            if (error.response.status === 401) {
                history.push(history.location.pathname);
                return {
                    status: "unauthorized",
                    message: msg ? msg : "Authentication error"
                };
            };

            // Handle 403 errors for tenant locked
            if (error.response.status === 403 && error.response.data.error === 'Unauthorized_Tenant_locked') {
                 window.location.href = '/blocked';
            }
            return error.response.data;
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            return {
                status: "error",
                message: error.request.statusText
                    ? error.request.statusText
                    : "Request error"
            };
        } else {
            // Something happened in setting up the request that triggered an Error
            return {
                status: "error",
                message: error.message ? error.message : "Request setup error"
            };
        }
    };

    // New list() method to fetch data to accomodate BE changes for the next-gen dashboard
    list = (cls, endpoint, params, handler = false) => {
        let self = this;
        let instance = this.init();
        instance.defaults.responseType = "json";
        let callback = handler;

        // Make the GET request using axios
        return instance
            .get(endpoint, { params }) // Pass the 'params' object as query parameters
            .then(response => {
                return response.data ? response.data : []; // Return the response data if it's not empty, otherwise return an empty array
            })
            .catch(error => {
                return self.handleError(error); // Call the 'handleError' method of the current instance to handle errors
            })
            .then(response => {
                if (callback) callback(response); // Call the 'callback' function if it's provided
                return response; // Return the response
            });
    };
}

export default new Request();
